export const FAQData = [
    {
        title: 'What information is needed prior to registering a warranty?',
        content: 'The information needed to register a warranty includes installation date, shingle type, shingle color and number of squares.',
    },
    {
        title: 'Where do I register my warranty?',
        content: 'To make it convenient, click on the "Register a Warranty" link below or call 1-800-ROOFING to register your warranty.',
    },

    {
        title: 'How do I transfer my warranty?',
        content: 'Warranties can be transferred to the second owner of the roof as long as the transfer occurs within 60 days of the real estate transfer. Warranties can be transferred by clicking on the "Transfer a Warranty" link below or calling 1-800-ROOFING. When you call, please be prepared to provide documentation including proof of purchase, proof of ownership and transfer fee based on the year your roof was installed.',
    },
    {
        title: 'How do I file a claim for my roof?',
        content: 'We\'ve made it convenient for you to file your claim online. Please click on the "File a Claim" link below.',
    },
    {
        title: 'Who is authorized to install Owens Corning<sup>&reg;</sup> Roofing shingles?',
        content: 'Having your roof installed by an Owens Corning® Roofing Platinum or Preferred Contractor can have a big impact on your warranty coverage. For standard product limited warranties, anyone can install provided the proper installation instructions and local building codes are followed. For extended warranty protection options, an Owens Corning Roofing Platinum or Preferred Contractors are the only roofing professionals authorized to install.',
    },

    {
        title: 'What does ‘Limited Lifetime’ Warranty mean?',
        content: 'As an owner of a single family detached home, lifetime coverage means that your warranty is in effect for manufacturing defects as long as you own your home. Coverage period is reduced for non-single family or commercial structures.',
    },
    {
        title: 'Who is authorized to provide an extended warranty?',
        content: 'Owens Corning® Roofing Platinum and Preferred Contractors are the only roofing professionals authorized to provide an extended warranty.        ',
    },
    {
        title: 'What products are required to obtain an extended warranty?',
        content: 'In 2018, the current requirements to obtain an extended warranty include the following:<ul>\
        <li>System Protection Total Protection Roofing System<sup>&reg;</sup> (TPRS) Warranties: Hip & Ridge shingles plus two other accessories</li>\
        <li>Platinum Protection/Preferred Protection Warranties: Hip & Ridge shingles plus three other accessories</li>\
        <li>Exception: If your roof has Supreme<sup>&reg;</sup> shingles, Owens Corning<sup>&reg;</sup> Hip & Ridge is not required as long as the total number of required accessories is met for each warranty.</li></ul>',
    },

    {
        title: 'What is the TRU PROtection<sup>&reg;</sup> period?',
        content: 'Each warranty starts with a TRU PROtection® Period during the initial years where coverage includes labor cost to repair/replace defective materials. The specific length of the TRU PROtection® period varies by type of warranty and shingle installed. Please refer to the warranty table for the shingle you are considering.',
    },
    {
        title: 'What number can I contact regarding warranty/claim questions?',
        content: 'Please call 1-800-Roofing between the hours of 8am-8pm EST.',
    },
]